const { Howl } = require("howler");

const dingSound = require("sound/ding.mp3");
const carAlarmSound = require("sound/car_alarm.mp3");
const chatSentSound = require("sound/chat_sent.mp3");
const chatReceivedSound = require("sound/chat_received.mp3");

// Howl instances are created once, at module load, instead of via `use-sound`'s
// per-component hook: `use-sound` only calls `.play()` once its own `onload`
// state fires, so a click that arrives before that (e.g. the first message
// sent right after opening the chat) is silently dropped. Howler itself
// queues `.play()` calls made while a sound is still loading and flushes them
// once ready, so plain Howl instances don't have that race.
const ding = new Howl({ src: [dingSound] });
const carAlarm = new Howl({ src: [carAlarmSound] });
const chatSent = new Howl({ src: [chatSentSound] });
const chatReceived = new Howl({ src: [chatReceivedSound] });

// Defined once at module scope (not inside Sound()) so callers get the same
// function reference on every call, keeping them safe to use in useEffect/
// useCallback dependency arrays.
const playDing = () => { ding.play(); };
const playCarAlarm = () => { carAlarm.play(); };
const playChatSent = () => { chatSent.play(); };
const playChatReceived = () => { chatReceived.play(); };

// Set by the chat page when the user leaves it, so that CurrentTrips (which is
// shown right after) doesn't play the "ding" meant for freshly opened trips.
let skipNextDing = false;
export const skipNextDingSound = () => { skipNextDing = true; };
export const consumeSkipDing = () => {
  const skip = skipNextDing;
  skipNextDing = false;
  return skip;
};

export default function Sound(){
  return {
    playDing,
    playCarAlarm,
    playChatSent,
    playChatReceived,
  }
}
